import { Toast } from "vant";

const getLoadingHtml = (message: string, progress?: number) => {
  return `
    <div class="ddd-loading">
      <div class="icon"></div>
      ${
        typeof progress !== "undefined"
          ? `<div class="progress">${progress}%</div>`
          : ""
      }
      <div class="message">${message}</div>
    </div>
  `;
};

let loadingIdCount = 1;

export function loading(message: string, initProgress?: number) {
  loadingIdCount++;
  const idClass = `ddd-loading-id-${loadingIdCount}`;

  const toast = Toast.loading({
    duration: 0,
    forbidClick: true,
    overlay: true,
    type: "html",
    className: `ddd-loading-toast ${idClass}`,
    message: getLoadingHtml(message, initProgress),
  });

  return {
    setMessage: (message: string) => {
      (document.querySelector(
        `.${idClass} .message`
      ) as HTMLDivElement).innerText = `${message}`;
    },
    setProgress: (progress: number) => {
      const progressEl = document.querySelector(
        `.${idClass} .progress`
      ) as HTMLDivElement;

      if (progressEl) {
        progressEl.innerText = `${progress}%`;
      } else {
        throw new Error("调用 loading 时请传入 initProgress");
      }
    },
    clear: () => {
      toast.clear();
    },
  };
}
